import React, { forwardRef } from "react";
import Box, { BoxProps } from "../box/Box";

const sizes = {
  "2xl": ["4xl", null, "5xl"],
  xl: ["2xl", null, "3xl"],
  lg: ["xl", null, "2xl"],
  md: "xl",
  sm: "md",
  xs: "sm",
};

interface IHeading {
  size?: "2xl" | "xl" | "lg" | "md" | "sm" | "xs";
}

export type HeadingProps = IHeading & Omit<BoxProps, "size">;

const Heading = forwardRef<any, HeadingProps>(({ size = "xl", ...props }, ref) => {
  const fontSize = sizes[size] as IHeading["size"];

  return (
    <Box
      ref={ref}
      as="h2"
      fontSize={fontSize}
      lineHeight="base"
      fontWeight="bold"
      fontFamily="body"
      mb={0}
      {...props}
    />
  );
});

Heading.displayName = "Heading";

export default Heading;
